import {
  Divider,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Box,
} from "@mui/material";

const AppPermission = () => {
  const tableData = [
    ["Location", "Enable real-time location tracking every 15 seconds in both foreground and background, activated only after the user has checked in — required to track check-ins, customer visits, and payments."],
    ["Camera", "Captures images of customer places, receipts, or documents"],
    ["Storage(if used)", "Allows saving or exporting PDF receipts and invoices locally"],
    ["Internet", "Required to sync data with backend servers and for real‑time updates"],
  ];

  return (
    <Box>
      <Typography variant="h4" fontWeight="bold" gutterBottom>
        7. App Permissions Explained
      </Typography>

      {/* <TableContainer
        component={Paper}
        sx={{
          my: 2,
          border: "1px solid #ccc",
          borderRadius: 2,
          overflow: "hidden",
          boxShadow: "none",
        }}
      >
        <Table
          sx={{
            minWidth: 700,
            borderCollapse: "collapse",
          }}
          aria-label="app permissions table"
        >
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  fontWeight: 600,
                  fontSize: "1rem",
                  borderBottom: "2px solid #ccc",
                  borderRight: "1px solid #ccc",
                  backgroundColor: "#fafafa",
                  width: "30%",
                  whiteSpace: "nowrap",
                  py: 1.5,
                }}
              >
                Permission
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: 600,
                  fontSize: "1rem",
                  borderBottom: "2px solid #ccc",
                  backgroundColor: "#fafafa",
                  py: 1.5,
                }}
              >
                Purpose
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {tableData.map(([permission, purpose], idx) => (
              <TableRow key={idx} hover>
                <TableCell
                  sx={{
                    fontSize: "0.95rem",
                    borderBottom: "1px solid #e0e0e0",
                    borderRight: "1px solid #ccc",
                    verticalAlign: "top",
                    py: 1.5,
                    whiteSpace: "nowrap",
                  }}
                >
                  {permission}
                </TableCell>
                <TableCell
                  sx={{
                    fontSize: "0.95rem",
                    color: "#444",
                    borderBottom: "1px solid #e0e0e0",
                    py: 1.5,
                  }}
                >
                  {purpose}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer> */}

      <div
  style={{
    margin: "16px 0",
    border: "1px solid #ccc",
    borderRadius: "8px",
    overflow: "hidden",
    boxShadow: "none",
  }}
>
  <table
    aria-label="app permissions table"
    style={{
      width: "100%",
      minWidth: 700,
      borderCollapse: "collapse",
    }}
  >
    <thead>
      <tr>
        <th
          style={{
            fontWeight: 600,
            fontSize: "1rem",
            borderBottom: "2px solid #ccc",
            borderRight: "1px solid #ccc",
            backgroundColor: "#fafafa",
            width: "30%",
            whiteSpace: "nowrap",
            padding: "12px",
            textAlign: "left",
          }}
        >
          Permission
        </th>
        <th
          style={{
            fontWeight: 600,
            fontSize: "1rem",
            borderBottom: "2px solid #ccc",
            backgroundColor: "#fafafa",
            padding: "12px",
            textAlign: "left",
          }}
        >
          Purpose
        </th>
      </tr>
    </thead>

    <tbody>
      {tableData.map(([permission, purpose], idx) => (
        <tr
          key={idx}
          style={{
            cursor: "default",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.backgroundColor = "#f5f5f5")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.backgroundColor = "transparent")
          }
        >
          <td
            style={{
              fontSize: "0.95rem",
              borderBottom: "1px solid #e0e0e0",
              borderRight: "1px solid #ccc",
              verticalAlign: "top",
              padding: "12px",
              whiteSpace: "nowrap",
            }}
          >
            {permission}
          </td>
          <td
            style={{
              fontSize: "0.95rem",
              color: "#444",
              borderBottom: "1px solid #e0e0e0",
              padding: "12px",
            }}
          >
            {purpose}
          </td>
        </tr>
      ))}
    </tbody>
  </table>
</div>


      <Typography mt={2} sx={{ fontSize: "1.05rem", color: "#555" }}>
        All permissions are clearly disclosed in the Play Store listing and are used solely to enable the app’s core functionalities.
      </Typography>

      <Divider sx={{ my: 3 }} />
    </Box>
  );
};

export default AppPermission;
